import useGlobalLocation from 'components/globalLocationSelector/hooks/useGlobalLocation';
import LoadingPanel from 'components/loadingPanel/LoadingPanel';
import useYardCheckSummary from 'features/yardCheck/hook/useYardCheckSummary';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { YARD_CHECK_STATUS } from 'utils/constants';
import CompleteContent from './CompleteContent';
import ReviewContent from './ReviewContent';

const HelpDialogSummary = () => {
    const { selectedLocationId } = useGlobalLocation();
    const { id: summaryId } = useParams();
    const { yardCheckInfo, fetchYardCheckSummary } = useYardCheckSummary({
        summaryId,
        selectedLocationId,
    });

    useEffect(() => {
        if (summaryId) {
            fetchYardCheckSummary();
        }
    }, [summaryId, fetchYardCheckSummary]);

    return (
        <>
            {!yardCheckInfo && <LoadingPanel visible={false} />}
            {yardCheckInfo?.status === YARD_CHECK_STATUS.CHECKING ? <ReviewContent /> : <CompleteContent />}
        </>
    );
};

export default HelpDialogSummary;
